"use client";
import { TaxiFormProps } from "@/components/TaxiForm/types";
import "./style.css";
import TaxiForm from "../../TaxiFormMain";

// Diference for single step forms are the styles at the moment
export default function SingleStepTaxiForm(props: TaxiFormProps) {
  return <TaxiForm {...props} formClass="taxi-form-single" />;
}
